export var swap = function (obj) {
    return Object.fromEntries(Object.entries(obj).map(function (a) { return a.reverse(); }));
};
